<template>
  {{ field.name }}
  <v-radio-group
    :rules="fieldRules"
    :model-value="modelValue"
    :hint="field.description"
    @update:model-value="onInput">
    <v-radio
      v-for="option of field.options"
      :id="option.id"
      :label="option.name"
      :value="option.name"></v-radio>
  </v-radio-group>
</template>
<script setup lang="ts">
import { EntryFieldDTO, FieldTypeEnum, IEntryFieldDTO } from '@/dtos';
import { rules } from '@/helpers';

import { ref, watch } from 'vue';

const props = defineProps<{
  field: IEntryFieldDTO;
  modelValue?: string;
}>();
const field = ref<IEntryFieldDTO>(new EntryFieldDTO());

const fieldRules = ref<((value: string) => true | string)[]>([]);

const emit = defineEmits<{
  (e: 'update:modelValue', fieldId: string, value: string): void;
}>();

const onInput = (value: string | null) => {
  if (!value) {
    value = '';
  }
  emit('update:modelValue', field.value.id, value);
};

watch(
  () => props.field,
  () => {
    fieldRules.value = [];
    if (props.field) {
      field.value = new EntryFieldDTO(props.field);
    } else {
      field.value = new EntryFieldDTO();
    }

    if (field.value.is_required) {
      fieldRules.value.push(rules.required);
    }

    if (field.value.type == FieldTypeEnum.Number) {
      fieldRules.value.push(rules.numeric);
    }
  },
  { immediate: true },
);
</script>
